/// <amd-module name="VSSUI/Components/PeoplePicker/index" />
export * from "./PeoplePicker";
export { IPeoplePicker, IPeoplePickerProps } from "./PeoplePicker.Props";
export * from "./PeoplePickerUtils";
export { IIdentity, IPeoplePickerProvider, IPersonaConnections, ISharedPeoplePickerProps } from "./SharedPeoplePicker.Props";
export * from "./Suggestions";
export { ISuggestionItemProps } from "./Suggestions.Props";
